import React, { Component } from 'react';
import FormBox from '../Login/FormBox';
import PasswordForm from '../Password/PasswordForm';
import Header from '../Header/Header';


export default class Password extends Component {
  render() {
    return (
      <div className="password">
        <Header title="Alterar senha" backbutton={this.props.history}/>
        <FormBox>
          <PasswordForm />
        </FormBox>
      </div>
    )
  }
}
